import { reseedOnReconnect } from '@ahaslides-product/frontend-toolkit'
import store from '@/store'
import kvSyncSubscriber from '@/mqtt/kvSync'
import mqttClient from '@/mqtt/mqtt.client'
import Sentry from '@/3rd-parties/sentry'

function init() {
  kvSyncSubscriber.init()

  // Counting is published non-retained, so updates sent while the connection was down never arrive.
  // Spread over 30s: a broker node restart reconnects every audience member on it at once.
  reseedOnReconnect({
    mqttClient,
    store,
    captureException: Sentry.captureException,
    options: { maxDelayMs: 30000 },
  })
}

export default { init }
